import { font } from '../../styles';
import { styled } from '../../utils';
import { Card, CardContent } from '../Card';
import { Icon } from '../Icon';
import { Tooltip } from '../Tooltip';
import { Typography } from '../Typography';
//TODO: add cursor pointer for party click
//Question to TODO above: should we add cursor: pointer to the whole card?
//I thought only the name should be the redirect link, or is this meant for the AutoComplete/Relation picker
export const ResultCardStyled = styled(Card, {
    shouldForwardProp: (prop) => prop !== 'active',
})(({ theme, active }) => ({
    borderRadius: theme.spacing(1),
    padding: theme.spacing(2),
    boxShadow: 'unset',
    //cursor: 'pointer',
    '&:hover': {
        backgroundColor: theme.palette.secondary.contrastText,
    },
    ...(active && {
        '&.MuiCard-root': {
            boxShadow: `0 0 0 2px ${theme.palette.primary.dark}`,
            backgroundColor: theme.palette.secondary.contrastText,
            '&:hover': {
                backgroundColor: theme.palette.secondary.contrastText,
            },
        },
    }),
}));
export const ResultCardContentStyled = styled(CardContent)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    rowGap: theme.spacing(2),
    width: '100%',
    padding: theme.spacing(1),
    '&:last-of-type': {
        paddingBottom: 'inherit',
    },
    [theme.breakpoints.up('xs')]: {
        //FIXME: get rid of important
        padding: `${theme.spacing(1)} !important`,
    },
}));
export const ResultCardAvatarIconStyled = styled(Icon)(({ theme, isSmall }) => ({
    fontSize: isSmall ? font.size.m : font.size['3xl'],
    margin: theme.spacing(0, 0.5, 0.5, 0),
    color: theme.palette.primary.dark,
    position: 'relative',
}));
export const ResultCardBaseDataStyled = styled('div')(({ theme }) => ({
    display: 'flex',
    flexWrap: 'nowrap',
    [theme.breakpoints.down('sm')]: {
        flexWrap: 'wrap',
    },
    gap: theme.spacing(2),
    justifyContent: 'space-between',
}));
export const ResultCardTitleStyled = styled(Typography)({
    lineHeight: '1',
});
export const ResultCardContactDataLinkStyled = styled('a')(({ theme }) => ({
    textDecoration: 'none', // remove <a> styles
    color: theme.palette.primary.main, // overwrite <a> styles
    cursor: 'pointer',
}));
export const ResultCardCaptionLabelStyled = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.main,
    flexWrap: 'nowrap',
}));
export const ResultCardIconStyled = styled(Icon)(({ theme }) => ({
    fontSize: theme.typography.h5.fontSize,
    marginRight: `calc(${theme.spacing(1)} - 2.4px)`,
    position: 'relative',
    top: theme.spacing(1 / 4),
    color: theme.palette.primary.main,
}));
export const ResultCardTextIconStyled = styled(Typography)({
    display: 'flex',
    alignItems: 'center',
});
export const ResultCardDataContainerStyled = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
}));
export const ResultCardDataWithIconStyled = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(0.3),
}));
export const ResultCardTooltipStyled = styled(Tooltip)({
    padding: '0 !important',
});
export const ResultCardSecondaryDataStyled = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
});
export const ResultCardSecondaryDataWrapperStyled = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    gap: theme.spacing(5),
}));
